<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 18.2505H21L18.7526 14.9999V8.56123C18.7524 7.69901 18.5775 6.84528 18.2379 6.04882C17.8982 5.25236 17.4005 4.52879 16.7732 3.91946C16.1459 3.31012 15.4012 2.82698 14.5817 2.49763C13.7623 2.16828 12.8841 1.99918 11.9974 2C11.1113 1.99984 10.2338 2.16944 9.4151 2.49911C8.59639 2.82879 7.85249 3.31208 7.2259 3.92138C6.59931 4.53068 6.1023 5.25405 5.76327 6.05016C5.42424 6.84628 5.24983 7.69955 5.25 8.56123V14.9999L3 18.2505Z"
      fill="white"
    />
    <path
      d="M9.42857 19.4995H14.5714C14.5714 20.1627 14.3005 20.7987 13.8183 21.2676C13.336 21.7366 12.682 22 12 22C11.318 22 10.664 21.7366 10.1817 21.2676C9.69949 20.7987 9.42857 20.1627 9.42857 19.4995Z"
      fill="white"
    />
    <circle cx="18" cy="5" r="3.5" fill="#F58413" stroke="#17181C" />
  </svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-notification'
});
</script>
